import React from 'react'

import { GetStaticPaths, GetStaticProps } from 'next'
import { ParsedUrlQuery } from 'querystring'
import { useRouter } from 'next/router'

import { Article, ServiceImage } from '@/components/services'
import { FileProvider } from '@/lib/files'
import ArticleSEO from '@/components/blog/article_seo'
import { IData } from '@/components/blogImg'
import Config from '../../site.config'
import ContactHome from '@/components/contact/ContactHome'
import Meta from '@/components/Meta'

interface IProps {
  data: IData
}

const ServiceItem = (props: IProps) => {
  const router = useRouter()
  const pid = router.query.service_item
  const { data } = props
  const { title, date, image } = data.metadata

  const p = router.asPath.slice(1)
  const canonicalURL = `${Config.site.URL}/${p}`.split('?')[0]

  return (
    <div>
      <Meta title={`${pid}`} canonicalURL={canonicalURL} />
      <ArticleSEO metadata={data.metadata} />
      <main className='pt-[5.5rem] lg:pt-24'>
        <header className='mx-auto m-16 max-w-lg text-center'>
          <div className='mb-3 inline-flex flex-wrap items-center space-x-1 text-xs'>
            <h1 className='mb-4 font-display text-2xl text-jacarta-700 dark:text-white sm:text-5xl'>
              {title}
            </h1>
          </div>
        </header>

        <div className='md:container md:lay'>
          {/* Featured image */}
          <ServiceImage meta={data.metadata} slug={data.slug} />
          <Article content={data.content} />
        </div>
        <ContactHome />
      </main>
    </div>
  )
}

export default ServiceItem

export const getStaticPaths: GetStaticPaths = async () => {
  const provider = new FileProvider()
  const postList = provider.getServices()

  const paths = postList.map((file: IData) => ({
    params: { service_item: file.slug },
  }))

  return { paths, fallback: false }
}

interface IParams extends ParsedUrlQuery {
  service_item: string
}

export const getStaticProps: GetStaticProps = async (context) => {
  const provider = new FileProvider()
  const postList = provider.getServices()

  const { service_item } = context.params as IParams

  const postData = postList.find((item) => {
    return item.slug == service_item
  })

  return { props: { data: postData } }
}
